// extracted by mini-css-extract-plugin
export default {"error-container":"LocalErrorDisplay_error-container__rBTMk","error-text-container":"LocalErrorDisplay_error-text-container__ZFg0I"};